import { CardProps } from '@mui/material'
import { AlertSource, RuuviTag } from '../types'
import EnableAlertNotificationsAlert from './EnableAlertNotificationsAlert'
import RuuviTagActiveAlertsWarning from './RuuviTagActiveAlertsWarning'
import useLoadingAlerts from '../hooks/useLoadingAlerts'
import { useRuuviTagBatteryLoader, useRuuviTagConditionLoader } from '../loaders'
import ActiveAlertsCard from './ActiveAlertsCard'

export interface RuuviTagActiveAlertsCardProps extends Omit<CardProps, 'children'> {
  ruuviTag: RuuviTag
  source?: AlertSource
}

export default function RuuviTagActiveAlertsCard({
  ruuviTag,
  source = 'prometheus',
  ...props
}: RuuviTagActiveAlertsCardProps) {
  /**
   * The alerts state.
   */
  const { alerts, loading } = useLoadingAlerts({
    ruuvitag: ruuviTag.id,
    source
  })

  /**
   * The ruuvitag condition.
   */
  const { ruuviTagCondition } = useRuuviTagConditionLoader(ruuviTag.id)

  /**
   * The ruuvitag battery.
   */
  const { ruuviTagBattery } = useRuuviTagBatteryLoader(ruuviTag.id)

  return (
    <>
      {alerts.length > 0 && (
        <RuuviTagActiveAlertsWarning
          ruuviTag={ruuviTag}
          alerts={alerts}
          sx={{ mb: 6, width: '100%' }}
        />
      )}

      <EnableAlertNotificationsAlert ruuviTag={ruuviTag} sx={{ mb: 6, width: '100%' }} />

      <ActiveAlertsCard
        alerts={alerts}
        ruuviTagCondition={ruuviTagCondition}
        ruuviTagBattery={ruuviTagBattery}
        {...props}
      />
    </>
  )
}
